import React from 'react';

import QRCode from 'react-qr-code';

import CloseIcon from '@mui/icons-material/Close';
import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';

export interface IQRModal {
  open: boolean;
  onClose: () => void;
  value: string | undefined | null;
}

const QRModal = (props: IQRModal) => {
  const { onClose, open, value } = props;
  return (
    <Dialog
      maxWidth='xl'
      open={open}
      scroll={'paper'}
      aria-labelledby='form-dialog-title'
      onClose={onClose}>
      <DialogTitle sx={{ padding: '20px' }}>
        <IconButton
          aria-label='close'
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 3,
            top: 2,
            color: (theme) => theme.palette.grey[500],
          }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ padding: '30px' }}>
        <QRCode value={value ?? ''} />
      </DialogContent>
    </Dialog>
  );
};

export default QRModal;
